import React from "react";
import { Button } from "@sscs/ui";
import { InventoryIcon as PackageIcon } from "@sscs/ui/icons";
import { ButtonColor } from "Types";
import CreateCiCdPackage from "../../assets/create_cicd_package.svg";
import CreateCiCdPackageDisabled from "../../assets/create_cicd_package_disabled.svg";
import CreateProject from "../../assets/create_project.svg";
import CreateProjectDisabled from "../../assets/create_project_disabled.svg";
import styles from "./createNewButton.module.scss";

type IconType = "project" | "ci-cd-package" | "release-package";
type ButtonSize = "small" | "medium" | "large";

const icons: Record<IconType, React.JSX.Element> = {
  project: <CreateProject className={styles["project-icon"]} />,
  "ci-cd-package": <CreateCiCdPackage />,
  "release-package": <PackageIcon />,
};

const disabledIcons: Record<IconType, React.JSX.Element> = {
  project: <CreateProjectDisabled className={styles["project-icon"]} />,
  "ci-cd-package": <CreateCiCdPackageDisabled />,
  "release-package": <PackageIcon />,
};

const buttonText: Record<IconType, string> = {
  project: "Create project",
  "ci-cd-package": "Create package",
  "release-package": "Create package",
};

type CreateNewButtonProps = {
  id: string;
  type: IconType;
  showLabel?: boolean;
  disabled?: boolean;
  size?: ButtonSize;
  onClick: () => void;
  color?: ButtonColor;
};

const CreateNewButton = ({
  id,
  type,
  showLabel = true,
  disabled = false,
  size = "medium",
  onClick,
  color = "primary",
}: CreateNewButtonProps): React.JSX.Element => (
  <Button
    id={id}
    size={size}
    color={color}
    tooltipTitle={showLabel ? undefined : buttonText[type]}
    disabled={disabled}
    onClick={onClick}
  >
    {disabled ? disabledIcons[type] : icons[type]}{" "}
    {showLabel && <span className={styles.text}>{buttonText[type]}</span>}
  </Button>
);

export default CreateNewButton;
